import {Container, Paper} from "@mui/material";
import SaleForm from "../components/SaleForm.tsx";
import {useParams} from "react-router-dom";
import {useContext, useEffect} from "react";
import SaleContext from "../contexts/SaleContext.tsx";

const EditSalePage = () => {
    const {id} = useParams<{ id: string }>()
    const {setSelectedSaleId} = useContext(SaleContext)

    useEffect(() => {
        setSelectedSaleId(id)
    }, [id]);

    return (
        <Container sx={{padding: '12px'}}>
            <Paper
                elevation={4}
                sx={{
                    maxWidth: '900px',
                    margin: 'auto',
                    padding: 2,
                }}
            >
                <SaleForm isCreate={false}/>
            </Paper>
        </Container>
    )
}

export default EditSalePage;
